// extracted by mini-css-extract-plugin
export default {"buttonContainer":"button-item-secondary-module__buttonContainer--CvTJa"};